import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  API,
  GlobalActions,
  SidePanelContainer,
  SidePanelHeader,
  SidePanelContent,
  TableScreenResolutions,
  VibeIcon,
  viClose,
  color,
} from 'vibeguide';
// import CompanyBannerEdit from './CompanyBannerEdit';

function ImportResolutions({
  onClose,
}) {
  return (
    <SidePanelContainer className="ImportResolutions">
      <SidePanelHeader
        icons={(
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <VibeIcon
              className="close"
              icon={viClose}
              color={color.manatee}
              hoverColor={color.obsidian}
              size={24}
              onClick={onClose}
            />
          </div>
        )}
      >
        <div className="title">
          Resolutions
        </div>
      </SidePanelHeader>

      <SidePanelContent
        style={{
          display: 'flex',
          padding: 0,
        }}
      >
        <TableScreenResolutions
          columns={[
            'Name',
            'Width',
            'Height',
          ]}
          available
          fetch={API.ScreenResolution.list}
          defaultSortBy={{
            label: 'Name',
            attr: 'name',
            direction: 'asc',
          }}
          paginator
          paginatorProps={{
            label: 'Screen Resolutions',
            urlPaging: true,
            urlFilters: true,
          }}
          toggle
          toggleProps={{
            label: 'Show Archived Screen Resolutions',
            tooltip: true,
          }}
          rowLink={{
            resolutionId: '_id',
          }}
          menuItems={[
            { name: 'Archive', userCan: 'screen_resolution.delete' },
          ]}
        />
      </SidePanelContent>
    </SidePanelContainer>
  );
}

ImportResolutions.propTypes = {
  onClose: PropTypes.func,
};

ImportResolutions.defaultProps = {
  onClose: () => {},
};

function mapStateToProps(state) {
  return {
    user: state.login.user,
  };
}

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportResolutions);
